import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Goal',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("circle", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "4", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", cx: "16", cy: "12", r: "10" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "12", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "16", y1: "12", x2: "16", y2: "12" }
      }), h("path", {
        attrs: { d: "M29 28l-5.5-2-1.5 6-3.04-6.84a13.45 13.45 0 0 0 6.98-4.06L29 28zM6.06 21.11L3 28l5.5-2 1.5 6 3.04-6.84c-2.73-.61-5.15-2.06-6.98-4.05z" }
      })]
    );
  }
};